import { auth } from "../firebase"

function logout() {
  if (auth.currentUser) return auth.signOut()
  return null
}

export default logout
